import React from 'react';
import NavbarWithMenu from './NavbarWithMenu';
import { Outlet } from 'react-router-dom';

const LayoutWithNavbar = () => {
    return (
        <>
            <NavbarWithMenu />
            <div style={{ margin: '1.5rem 10%' }}>
                <Outlet />
            </div>
        </>
    );
};

export default LayoutWithNavbar;
